module.exports = __webpack_public_path__ + "static/media/engineer.eca06601.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/engineer.png
// module id = 505
// module chunks = 0